import { formatUsd } from "../../config/trading";

export function LiveAutomationSection({ liveAutomation, liveConfig, setLiveConfig, onToggleLiveAutomation }) {
  return (
    <>
      <label className="field-label" htmlFor="live-max-trade-input">USDT max per auto trade</label>
      <input
        id="live-max-trade-input"
        data-testid="live-max-trade-input"
        className="terminal-input"
        type="number"
        max="50"
        value={liveConfig.max_trade_usdt}
        onChange={(event) => setLiveConfig((current) => ({ ...current, max_trade_usdt: event.target.value }))}
      />
      <div className="check-row" data-testid="live-symbol-checkboxes">
        <label><input data-testid="live-btc-checkbox" type="checkbox" checked={liveConfig.btc} onChange={(event) => setLiveConfig((current) => ({ ...current, btc: event.target.checked }))} /> BTC</label>
        <label><input data-testid="live-eth-checkbox" type="checkbox" checked={liveConfig.eth} onChange={(event) => setLiveConfig((current) => ({ ...current, eth: event.target.checked }))} /> ETH</label>
        <label><input data-testid="live-sol-checkbox" type="checkbox" checked={liveConfig.sol} onChange={(event) => setLiveConfig((current) => ({ ...current, sol: event.target.checked }))} /> SOL</label>
        <label><input data-testid="live-okb-checkbox" type="checkbox" checked={liveConfig.okb} onChange={(event) => setLiveConfig((current) => ({ ...current, okb: event.target.checked }))} /> OKB</label>
      </div>
      <label className="field-label" htmlFor="automation-frequency-select">Check frequency</label>
      <select
        id="automation-frequency-select"
        data-testid="automation-frequency-select"
        className="terminal-input"
        value={liveConfig.interval_seconds}
        onChange={(event) => setLiveConfig((current) => ({ ...current, interval_seconds: Number(event.target.value) }))}
      >
        <option value={300}>Every 5 minutes</option>
        <option value={900}>Every 15 minutes</option>
        <option value={3600}>Hourly</option>
      </select>
      <div className="check-row" data-testid="automation-mode-checkboxes">
        <label><input data-testid="paper-automation-checkbox" type="checkbox" checked={liveConfig.paper_enabled} onChange={(event) => setLiveConfig((current) => ({ ...current, paper_enabled: event.target.checked }))} /> Paper</label>
        <label><input data-testid="live-automation-ready-checkbox" type="checkbox" checked readOnly /> Live when keys saved</label>
      </div>
      <button
        data-testid="live-automation-toggle-button"
        className={liveAutomation.enabled ? "danger-button wide" : "primary-button wide"}
        onClick={onToggleLiveAutomation}
      >
        {liveAutomation.enabled ? "Stop USDT Auto" : "Enable USDT Auto"}
      </button>
      <div className="range-box" data-testid="live-automation-status">
        <span>CYCLES <b className="mono">{liveAutomation.cycle_count}</b></span>
        <span>MAX <b className="mono">{formatUsd(liveAutomation.max_trade_usdt)}</b></span>
        <span>FREQ <b className="mono">{Math.round(liveAutomation.interval_seconds / 60)}m</b></span>
      </div>
    </>
  );
}